import React, { useState, useEffect } from "react";

function Desserts() {

    const [desserts, setDesserts] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'DESERY');

            if (category) {
                setDesserts(category.menu_items);
            };
        });
    }, []);

    return(

        <div className="container-fluid">
            <div className="container pb-5">
            <p className="menu-item-title-font fs-1 fw-bold pt-5">DESERY</p>
            <hr/>
            {desserts.map((dessert) => (
                <div key={dessert.id} className="container">
                    {dessert.name && dessert.price && (
                        <div className="dish-name-container d-flex justify-content-between">
                            <p className="menu-item-title-font fs-5 m-0">{dessert.name}</p>
                            <p className="fs-5 m-0">{dessert.price}zł</p>
                        </div>
                    )}
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{dessert.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
        </div>
        </div>
    )
}

export default Desserts;